<div class="header">
  <div class="header-cont">
    <h2>{{ 'itin_list.title' | translate }}</h2>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <p>{{ 'itin_list.title_descr' | translate }}</p>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h3>{{ 'itin_list.last_added' | translate }}</h3>
  </div>
</div>

<div class="single-section margin-small top">
  <div class="section-cont">
    <mat-carousel
      #matCarousel
      [timings]="timings"
      [autoplay]="autoplay"
      [interval]="interval"
      [loop]="loop"
      [hideArrows]="hideArrows"
      [hideIndicators]="hideIndicators"
      [color]="color"
      [maxWidth]="maxWidth"
      [proportion]="proportion"
      [useKeyboard]="useKeyboard"
      [useMouseWheel]="useMouseWheel"
      [orientation]="orientation"
      [slides]="slides"
      [maintainAspectRatio]="maintainAspectRatio"
      [slideHeight]="slideHeight"
    >
      <mat-carousel-slide
        #matCarouselSlide
        *ngFor="let most_viewed_itin of (itinCarousel | slice:-10)"
        [image]="imageUrl(most_viewed_itin)"
        [overlayColor]="overlayColor"
        [hideOverlay]="hideOverlay"
      >
        <div class="carousel-list-page">
          <div class="carousel-cont">
            <h2>{{most_viewed_itin.itin_name[current_lang]}}</h2>
            <p>{{most_viewed_itin.short_descr[current_lang]}}</p>
            <button
              mat-raised-button
              [routerLink]="['/home/itinerari/'+most_viewed_itin.id]">
              {{ 'home.link_btn' | translate }}
            </button>
          </div>
        </div>
      </mat-carousel-slide>
    </mat-carousel>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont headers-with-filters">
    <h3>{{ 'itin_list.itin_list_title' | translate }}</h3>
    <div class="filters">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title *ngIf="!loadingTheme; else loadingThemeItinDesktop">
            {{ 'itin_list.filter_theme' | translate }}
          </mat-panel-title>
          <ng-template #loadingThemeItinDesktop>
            <mat-panel-title>
              {{ 'itin_list.filter_theme' | translate }}
              <mat-progress-spinner
                  matSuffix
                  color="primary"
                  mode="indeterminate"
                  [diameter]="24"
                  style="margin-left: 5px;">
              </mat-progress-spinner>
            </mat-panel-title>
          </ng-template>
        </mat-expansion-panel-header>
        <mat-selection-list color="primary" class="themes-filter" #themesFilterDesktop (selectionChange)="themesFilterFunction(false)">
          <mat-list-option *ngFor="let single_theme of themes_list" [value]="single_theme.name[current_lang]">
            {{single_theme.name[current_lang]}}
          </mat-list-option>
        </mat-selection-list>
      </mat-expansion-panel>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'itin_list.search_label' | translate }}</mat-label>
        <input matInput (keyup)="inputFilter($event)" class="input-filter" [placeholder]="'placeholder' | translate">
        <mat-icon *ngIf="!loadingSearch; else loadingSearchItinDesktop" matSuffix>search</mat-icon>
        <ng-template #loadingSearchItinDesktop>
          <mat-progress-spinner
              matSuffix
              color="primary"
              mode="indeterminate"
              [diameter]="24">
          </mat-progress-spinner>
        </ng-template>
      </mat-form-field>
    </div>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont headers-with-filters-smaller">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title *ngIf="!loadingTheme; else loadingThemeItinMobile">
          {{ 'itin_list.filter_theme' | translate }}
        </mat-panel-title>
        <ng-template #loadingThemeItinMobile>
          <mat-panel-title>
            {{ 'itin_list.filter_theme' | translate }}
            <mat-progress-spinner
                matSuffix
                color="primary"
                mode="indeterminate"
                [diameter]="24"
                style="margin-left: 5px;">
            </mat-progress-spinner>
          </mat-panel-title>
        </ng-template>
      </mat-expansion-panel-header>
      <mat-selection-list color="primary" class="themes-filter" #themesFilterMobile (selectionChange)="themesFilterFunction(true)">
        <mat-list-option *ngFor="let single_theme of themes_list" [value]="single_theme.name[current_lang]">
          {{single_theme.name[current_lang]}}
        </mat-list-option>
      </mat-selection-list>
    </mat-expansion-panel>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'itin_list.search_label' | translate }}</mat-label>
      <input matInput (keyup)="inputFilter($event)" class="input-filter" [placeholder]="'placeholder' | translate">
      <mat-icon *ngIf="!loadingSearch; else loadingSearchItinMobile" matSuffix>search</mat-icon>
      <ng-template #loadingSearchItinMobile>
        <mat-progress-spinner
            matSuffix
            color="primary"
            mode="indeterminate"
            [diameter]="24">
        </mat-progress-spinner>
      </ng-template>
    </mat-form-field>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <div *ngIf="!loading; else loadingPageItin" class="element-card">
      <mat-card *ngFor="let single_itin of itin_list_filtered | paginate: { itemsPerPage: itin_list_size, currentPage: itin_list_page + 1, totalItems: itin_list_total, id: 'paginationItin' }">
        <img mat-card-image [src]="imageUrl(single_itin)" [alt]="single_itin.itin_name[current_lang]">
        <mat-card-content>
          <a [routerLink]="['/home/itinerari/'+single_itin.id]"><h4>{{single_itin.itin_name[current_lang]}}</h4></a>
          <p>{{single_itin.short_descr[current_lang]}}</p>
          <mat-expansion-panel  class="mat-elevation-z0" (click)="togglePanel(single_itin.id)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>place</mat-icon>
              </mat-panel-title>
              <mat-panel-description>
                <ng-container *ngIf="single_itin.expanded_panel; else closedPanel">
                  {{ 'itin_list.hide_pois' | translate }}
                </ng-container>
                <ng-template #closedPanel>
                  {{ 'itin_list.show_pois' | translate }}
                </ng-template>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div>
              <ng-container *ngFor="let single_poi of single_itin.pois">
                <a [routerLink]="['/home/poi/' + single_poi.id]"><h4>{{single_poi.poi_name[current_lang]}}</h4></a>
                <p>{{single_poi.short_descr[current_lang]}}</p>
              </ng-container>
            </div>
          </mat-expansion-panel>
        </mat-card-content>
      </mat-card>
    </div>
    <ng-template #loadingPageItin>
      <div class="element-card">
        <mat-progress-spinner
            color="primary"
            mode="indeterminate">
        </mat-progress-spinner>
      </div>
    </ng-template>
    <pagination-controls
      *ngIf="itin_list_total > itin_list_size"
      class="pr-pagination"
      (pageChange)="pageChange($event)"
      id="paginationItin"
      [previousLabel]="'paginator.prev' | translate"
      [nextLabel]="'paginator.next' | translate"
    ></pagination-controls>
  </div>
</div>
